export var FileUploadError;
(function (FileUploadError) {
    FileUploadError["MAX_FILE_COUNT_EXCEEDED"] = "MAX_FILE_COUNT_EXCEEDED";
    FileUploadError["MAX_FILE_SIZE_EXCEEDED"] = "MAX_FILE_SIZE_EXCEEDED";
    FileUploadError["MAX_FILE_NAME_CHARACTER_LIMIT_EXCEEDED"] = "MAX_FILE_NAME_CHARACTER_LIMIT_EXCEEDED";
    FileUploadError["INVALID_FILE_TYPE"] = "INVALID_FILE_TYPE";
    FileUploadError["MAX_VIDEO_FILE_SIZE_EXCEEDED"] = "MAX_VIDEO_FILE_SIZE_EXCEEDED";
    FileUploadError["MAX_ALLOTTED_STORAGE_USED"] = "MAX_ALLOTTED_STORAGE_USED";
    FileUploadError["CARRIER_CUSTOM_MESSAGE"] = "CARRIER_CUSTOM_MESSAGE";
})(FileUploadError || (FileUploadError = {}));
//# sourceMappingURL=FileUploadError.js.map